import type { OnChangeFn } from "@dresscode-frontend/utility-types";
import { createContext, useContext } from "react";

import type { NumberScale } from "@/utils/number/scale";

import type { CompoundChartDatum } from "./types";

const UNINITIALIZED_CONTEXT = {};

export const CompoundChartContext = createContext(
  UNINITIALIZED_CONTEXT as {
    data: CompoundChartDatum[];
    scales: {
      valueScale: NumberScale;
      cumulativeScale: NumberScale;
    };
    hoveredDatum: CompoundChartDatum | undefined;
    onHoverDatumChange: OnChangeFn<CompoundChartDatum | undefined>;
  },
);

export function useCompoundChartContext() {
  const context = useContext(CompoundChartContext);
  if (context === UNINITIALIZED_CONTEXT) {
    throw new Error(
      "useCompoundChartContext must be used within a CompoundChartProvider",
    );
  }
  return context;
}
